import React, { useEffect } from 'react';
import './TermsOfUse.css';

const TermsOfUse = () => {
  useEffect(() => {
    // Load Calendly widget script dynamically
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="terms-page">
      {/* Sub Hero Banner */}
      <section
        className="terms-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="terms-hero__container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h1 className="terms-hero__title" style={{ marginBottom: '8px' }}>Terms Of Use</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">
              Home
            </a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Terms Of Use</span>
          </nav>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="terms-content-section">
        <div className="terms-content__container">
          <p className="terms-intro">
            Welcome to <a href="https://alquranlesson.com" className="terms-link">AlQuranLesson.com</a>. These Terms of Use ("Terms") govern your access to and use of our Website and services. By accessing or using the Website, you agree to be bound by these Terms. If you do not agree, please do not use the Website.
          </p>

          <p className="terms-sec-title">1. Services Provided</p>
          <p className="terms-text">
            AlQuranLesson.com provides online Quran lessons and related educational services. By registering on our Website, you agree to:
          </p>
          <ul className="terms-list">
            <li>Provide accurate and complete information.</li>
            <li>Use the services for personal, non-commercial purposes only.</li>
            <li>Comply with all applicable laws and regulations.</li>
          </ul>

          <p className="terms-sec-title">2. SMS and Call Communication</p>
          <p className="terms-text">By providing your phone number, you expressly consent to receive SMS (text messages) and phone calls from us for the following purposes:</p>
          <ul className="terms-list">
            <li>Confirming your registration or inquiries.</li>
            <li>Providing updates about your lessons, account, or schedule.</li>
            <li>Sending important service-related notifications (e.g., lesson reminders, rescheduling).</li>
            <li>Sending promotional offers, updates, or newsletters (you may opt-out at any time).</li>
          </ul>

          <p className="terms-sub-sub-title">Opt-Out Instructions:</p>
          <p className="terms-text">You can opt-out of receiving SMS messages at any time by replying "STOP" to any message. Upon receiving your opt-out request, we will stop sending SMS messages to your number. For assistance, you can contact us at <a href="mailto:info@alquranlesson.com" className="terms-link">info@alquranlesson.com</a>.</p>

          <p className="terms-sub-sub-title">Message and Data Rates:</p>
          <p className="terms-text">Standard messaging and data rates may apply, depending on your mobile carrier. AlQuranLesson.com is not responsible for any charges incurred as a result of SMS communication.</p>

          <p className="terms-sub-sub-title">Support:</p>
          <p className="terms-text">For help or questions regarding SMS communication, reply "HELP" to any message or contact us at <a href="mailto:info@alquranlesson.com" className="terms-link">info@alquranlesson.com</a>.</p>

          <p className="terms-sec-title">3. User Responsibilities</p>
          <p className="terms-text">You agree to:</p>
          <ul className="terms-list">
            <li>Not share your account credentials with others.</li>
            <li>Not use the Website for any illegal or unauthorized purpose.</li>
            <li>Not engage in any activity that disrupts or interferes with the Website's functionality.</li>
          </ul>

          <p className="terms-sec-title">4. Payment Terms (if applicable)</p>
          <p className="terms-text">If you purchase any services, you agree to:</p>
          <ul className="terms-list">
            <li>Pay all fees as described on the Website.</li>
            <li>Provide accurate billing and payment information.</li>
            <li>Authorize us to charge your payment method for the services.</li>
          </ul>

          <p className="terms-sec-title">5. Intellectual Property</p>
          <p className="terms-text">All content on the Website, including text, graphics, logos, and software, is the property of AlQuranLesson.com or its licensors and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our prior written consent.</p>

          <p className="terms-sec-title">6. Limitation of Liability</p>
          <p className="terms-text">To the fullest extent permitted by law, AlQuranLesson.com shall not be liable for any indirect, incidental, special, or consequential damages arising out of or related to your use of the Website or services.</p>

          <p className="terms-sec-title">7. Termination</p>
          <p className="terms-text">We reserve the right to terminate or suspend your access to the Website at any time, without notice, for any reason, including violation of these Terms.</p>

          <p className="terms-sec-title">8. Governing Law</p>
          <p className="terms-text">These Terms are governed by the laws of [Insert Jurisdiction]. Any disputes arising from these Terms shall be resolved in the courts of applicable jurisdiction.</p>

          <p className="terms-sec-title">9. Changes to These Terms</p>
          <p className="terms-text">We may update these Terms from time to time. Any changes will be posted on this page with an updated effective date. Your continued use of the Website after changes constitutes your acceptance of the revised Terms.</p>

          <p className="terms-sec-title">10. Contact Us</p>
          <p className="terms-text">If you have any questions about these Terms, please contact us at:</p>
          <p className="terms-text" style={{ marginBottom: '0' }}>
            <a href="mailto:info@alquranlesson.com" className="terms-link">info@alquranlesson.com</a> | <a href="tel:+17164577657" className="terms-link">+1 (716) 457-7657</a>
          </p>
        </div>
      </section>

      {/* Free Consultation Call & Calendly Widget Section */}
      <section
        className="consultation-section"
        id="consultation"
        style={{
          '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-texas/edb9b1a643ea3ab6044ffcbbb4fe0032.png')`
        }}
      >
        <div className="consultation-section__container">
          <div className="consultation-section__header">
            <h2 className="consultation-section__title">
              FREE CONSULTATION CALL – Ask From Experts
            </h2>
            <div className="consultation-section__subtitle">
              <ul style={{ listStyleType: 'disc', display: 'inline-block', textAlign: 'left', paddingLeft: '20px', margin: '0 auto' }}>
                <li>Get answers to your questions – Find about our Holy Quran learning services</li>
                <li>Recommendations & suggestions from experts</li>
              </ul>
            </div>
          </div>

          <div className="consultation-section__grid">
            <div className="consultation-section__widget-container">
              <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/alquranlesson/call-consultation"
                style={{ minWidth: '320px', height: '700px' }}
              />
            </div>

            <div className="consultation-section__info">
              <h3 className="consultation-section__info-title">CONTACT INFO</h3>
              <ul className="consultation-section__list">
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <a href="https://maps.google.com/?q=Mississauga,+Ontario,+L5K,+1W2" target="_blank" rel="noopener noreferrer" className="consultation-section__link">
                    Mississauga, Ontario, L5K, 1W2
                  </a>
                </li>
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+17164577657" className="consultation-section__link">+1 716 457 7657 (USA)</a>
                </li>
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+16477385707" className="consultation-section__link">+1 647 738 5707 (Canada)</a>
                </li>
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a href="tel:+447441394281" className="consultation-section__link">+44 7441 394281 (UK)</a>
                </li>
                <li className="consultation-section__item">
                  <div className="consultation-section__icon-wrapper">
                    <svg className="consultation-section__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <a href="mailto:info@alquranlesson.com" className="consultation-section__link">info@alquranlesson.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUse;

